/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__NameInputs */

const en_help_center__shipping_n_delivery__name = /** @type {(inputs: Help_Center__Shipping_N_Delivery__NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping & Delivery`)
};

/**
* | output |
* | --- |
* | "Shipping & Delivery" |
*
* @param {Help_Center__Shipping_N_Delivery__NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__name = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__name(inputs)
});